/* eslint-disable react/no-array-index-key */
import clsx from 'clsx';
import React, { useState } from 'react';
import styles from './Winter.module.scss';
const pinkLight = `#FA6079`;
const orangelight = `#F6A754`;
const tealLight = `#4AC5BC`;
const purpleLight = `#654F8F`;
const greenLight = `#53B585`;
const blueLight = `#007CC2`;
const white = 'rgba(255, 255, 255, 0.6)';
const pinkBulb = `#FCAFBC`;
const orangeBulb = `#FAD3A9`;
const tealBulb = `#A4E2DD`;
const purpleBulb = `#B2A7C7`;
const greenBulb = `#A9DAC2`;
const blueBulb = `#80BDE0`;
const XmasLight = ({ xmasLightOn }) => (<svg className={clsx(styles.lights, xmasLightOn ? styles.on : styles.off)} width='400' height='45' viewBox='0 0 400 45' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <defs>
      <radialGradient id='pinkLight' cx='50%' cy='50%' r='50%' fx='50%' fy='50%'>
        <stop offset='0%' style={{ stopColor: pinkLight, stopOpacity: 1 }}/>
        <stop offset='100%' style={{ stopColor: white, stopOpacity: 1 }}/>
      </radialGradient>
      <radialGradient id='orangeLight' cx='50%' cy='50%' r='50%' fx='50%' fy='50%'>
        <stop offset='0%' style={{ stopColor: orangelight, stopOpacity: 1 }}/>
        <stop offset='100%' style={{ stopColor: white, stopOpacity: 1 }}/>
      </radialGradient>
      <radialGradient id='tealLight' cx='50%' cy='50%' r='50%' fx='50%' fy='50%'>
        <stop offset='0%' style={{ stopColor: tealLight, stopOpacity: 1 }}/>
        <stop offset='100%' style={{ stopColor: white, stopOpacity: 1 }}/>
      </radialGradient>
      <radialGradient id='purpleLight' cx='50%' cy='50%' r='50%' fx='50%' fy='50%'>
        <stop offset='0%' style={{ stopColor: purpleLight, stopOpacity: 1 }}/>
        <stop offset='100%' style={{ stopColor: white, stopOpacity: 1 }}/>
      </radialGradient>
      <radialGradient id='greenLight' cx='50%' cy='50%' r='50%' fx='50%' fy='50%'>
        <stop offset='0%' style={{ stopColor: greenLight, stopOpacity: 1 }}/>
        <stop offset='100%' style={{ stopColor: white, stopOpacity: 1 }}/>
      </radialGradient>
      <radialGradient id='blueLight' cx='50%' cy='50%' r='50%' fx='50%' fy='50%'>
        <stop offset='0%' style={{ stopColor: blueLight, stopOpacity: 1 }}/>
        <stop offset='100%' style={{ stopColor: white, stopOpacity: 1 }}/>
      </radialGradient>
    </defs>
    <circle id='pink-light' fill='url(#pinkLight)' cx='39.5' cy='21' r='4' className={clsx(styles.light, styles.odd)}/>
    <circle id='pink-bulb' fill={pinkBulb} cx='39.5' cy='21' r='1.5' className={styles.bulb}/>
    <path d='M37.5 13L39.5 21' stroke='#031545' strokeWidth='2'/>

    <circle id='orange-light' fill='url(#orangeLight)' cx='87.5' cy='0' r='4' className={clsx(styles.light, styles.even)}/>
    <circle id='orange-bulb' fill={orangeBulb} cx='87.5' cy='0' r='1.5' className={styles.bulb}/>
    <path d='M87.5 8V0' stroke='#031545' strokeWidth='2'/>

    <circle id='teal-light' fill='url(#tealLight)' cx='161' cy='23.5' r='4' className={clsx(styles.light, styles.odd)}/>
    <circle id='teal-bulb' fill={tealBulb} cx='161' cy='23.5' r='1.5' className={styles.bulb}/>
    <path d='M162.5 15L161 23.5' stroke='#031545' strokeWidth='2'/>

    <circle id='purple-light' fill='url(#purpleLight)' cx='240' cy='18' r='4' className={clsx(styles.light, styles.even)}/>
    <circle id='purple-bulb' fill={purpleBulb} cx='240' cy='18' r='1.5' className={styles.bulb}/>
    <path d='M237.5 27.5L240 18' stroke='#031545' strokeWidth='2'/>

    <circle id='green-light' fill='url(#greenLight)' cx='295.5' cy='40' r='4' className={clsx(styles.light, styles.odd)}/>
    <circle id='green-bulb' fill={greenBulb} cx='295.5' cy='40' r='1.5' className={styles.bulb}/>
    <path d='M297.5 31L295.5 40' stroke='#031545' strokeWidth='2'/>

    <circle id='blue-light' fill='url(#blueLight)' cx='363' cy='20' r='4' className={clsx(styles.light, styles.even)}/>
    <circle id='blue-bulb' fill={blueBulb} cx='363' cy='20' r='1.5' className={styles.bulb}/>
    <path d='M366.5 28.5L363 20' stroke='#031545' strokeWidth='2'/>
    <path d='M400 22C330 35 290 35 200 22C125.289 7.39454 80.5 0 0 22' stroke='#031545' strokeWidth='2'/>
  </svg>);
export const Winter = ({ xmas = false }) => {
    const [xmasLightOn, setXmasLightOn] = useState(false);
    return (<>
      {xmas && (<div className={styles.xmasLightSwitchContainer}>
          <p>Christmas lights</p>
          <label className={styles.xmasLightSwitch} htmlFor='xmas-light-switch'>
            <input id='xmas-light-switch' type='checkbox' checked={xmasLightOn} onChange={() => setXmasLightOn((p) => !p)}/>
            <span className={styles.slider}/>
          </label>
        </div>)}
      <div className={styles.snowflakeContainer}>
        {[...new Array(24)].map((_, idx) => (<span key={`${idx}-snowflake`} className={styles.winterItem}/>))}
      </div>

      {xmas && (<div className={styles.xmasLights}>
          <XmasLight xmasLightOn={xmasLightOn}/>
          <XmasLight xmasLightOn={xmasLightOn}/>
          <XmasLight xmasLightOn={xmasLightOn}/>
          <XmasLight xmasLightOn={xmasLightOn}/>
        </div>)}
    </>);
};
